module.exports = __webpack_public_path__ + "static/media/Landing Page Banner_Mobile 1x.a9090303.webp";